export const ImageBannerCss = {
  textOverlay: {
    position: "absolute" as const,
    content: "",
    left: 0,
    top: 0,
    background: "linear-gradient(to right, #0c171f 20%, transparent 100%)",
    height: "-webkit-fill-available",
    //@ts-ignore
    height: "93%",
    width: "100%",
    marginTop: "50px",
    alignItems: "center",
    display: "flex",
    paddingLeft: "100px"
  },
  title: {
    color: "#ffffff",
    fontSize: "80px",
    fontWeight: "700",
    margin: 0
  },
  subText: {
    fontSize: "35px",
    display: "inline-block",
    marginRight: "15px",
    fontWeight: "bold",
    color: "#fff",
    position: "relative" as const,
    zIndex: "2",
    margin: "15px 0 36px"
  },
  button: {
    color: "#ffffff",
    fontEeight: 600,
    fontSize: "16px",
    borderRadius: "5px",
    padding: "11px 25px",
    display: "inline-block",
    backgroundColor: "#f4181c"
  }
};
